import { motion } from "framer-motion"
import styled from "styled-components"

const variants = {
  container: {
    hidden: {
      width: 0,
      y: 4,
      transition: {
        delay: 0,
        duration: 0.5,
        ease: "easeIn",
      },
    },
    visible: {
      width: "max-content",
      y: 0,
      transition: {
        delay: 0.2,
        duration: 1.0,
        ease: "easeOut",
      },
    },
    whileTap: {
      scale: 0.9,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  },
  label: {
    hidden: {
      opacity: 0,
      transition: {
        duration: 0.5,
        ease: "easeIn",
      },
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.0,
        duration: 1.0,
        ease: "easeOut",
      },
    },
  },
}

const Container = styled(motion.div)`
  height: 36px;
  border-radius: 4px;
  background-color: rgb(54, 54, 54);
  width: max-content;
  overflow: hidden;
  padding: 8px 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const Label = styled(motion.span)`
  white-space: nowrap;
  margin: 0 12px;
  font-size: 1, 75rem;
`

const Caption = ({ title, onClick, className }) => {
  return (
    <Container
      onClick={onClick}
      variants={variants.container}
      initial={"hidden"}
      animate={"visible"}
      exit={"hidden"}
      whileTap={"whileTap"}
      className={className}
    >
      <Label variants={variants.label} initial={"hidden"} animate={"visible"} exit={"hidden"}>
        {title}
      </Label>
    </Container>
  )
}

export default Caption
